export const colors: Record<string, string> = {
  'concerto.metamodel@1.0.0.EnumDeclaration': 'lightsteelblue',
  'concerto.metamodel@1.0.0.ConceptDeclaration': 'lightgoldenrodyellow',
  'concerto.metamodel@1.0.0.ParticipantDeclaration': 'lightgreen',
  'concerto.metamodel@1.0.0.TransactionDeclaration': 'lightgray',
  'concerto.metamodel@1.0.0.EventDeclaration': 'lightpink',
  'concerto.metamodel@1.0.0.AssetDeclaration': 'lightsalmon',
};
